// 모바일 화면 확대 배율 — 사용자가 직접 조절(브라우저별 localStorage 저장).
// MobileScale(적용)·SidebarViewControls(사이드바 −/+ 조절 UI) 공용. 변경 시 커스텀 이벤트로 즉시 반영.
const KEY = 'gwMobileZoom';
export const MOBILE_ZOOM_EVENT = 'gw-mobilezoom';
export const ZOOM_MIN = 1.0;
export const ZOOM_MAX = 2.5;
export const ZOOM_STEP = 0.1;
// 기본 1.5 — 모바일 앱 가독성 계약. 기존 유효 저장값은 이 기본값보다 우선한다.
// 1.5에서는 좁아진 CSS 폭 때문에 채팅 컨트롤 줄바꿈·탭바 겹침 이력이 있으므로 실기기 회귀 확인이 필요하다.
export const ZOOM_DEFAULT = 1.5;
export const MIN_MOBILE_LAYOUT_WIDTH = 375;

// CSS zoom이 줄이는 레이아웃 폭을 최소 375px로 보존해 좁은 화면의 오른쪽 잘림을 막는다.
export function getViewportSafeMobileZoom(requestedZoom, viewportWidth) {
  const zoom = Number.isFinite(requestedZoom) && requestedZoom > 0 ? requestedZoom : 1;
  const width = Number.isFinite(viewportWidth) && viewportWidth > 0
    ? viewportWidth
    : MIN_MOBILE_LAYOUT_WIDTH;
  return Math.min(zoom, Math.max(1, width / MIN_MOBILE_LAYOUT_WIDTH));
}

export function getMobileZoom() {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === null) return ZOOM_DEFAULT;
    const v = Number.parseFloat(stored);
    return (v >= ZOOM_MIN && v <= ZOOM_MAX) ? v : ZOOM_DEFAULT;
  } catch (e) { return ZOOM_DEFAULT; }
}

// 배율 설정(범위 클램프 + 소수1자리 반올림). 반환=적용된 값. 전 구독자(MobileScale 등) 즉시 갱신.
export function setMobileZoom(v) {
  let z = Math.round(v * 10) / 10;
  if (z < ZOOM_MIN) z = ZOOM_MIN;
  if (z > ZOOM_MAX) z = ZOOM_MAX;
  try { localStorage.setItem(KEY, String(z)); } catch (e) { /* */ }
  try { window.dispatchEvent(new Event(MOBILE_ZOOM_EVENT)); } catch (e) { /* */ }
  return z;
}
